// extracted by mini-css-extract-plugin
module.exports = {"label":"TimeControlButton_label__1EktS"};